import * as CSS from 'csstype';
// Caveat Bold
import CaveatBoldEot from 'src/fonts/caveat/caveat-v9-latin_cyrillic-700.eot';
import CaveatBoldSvg from 'src/fonts/caveat/caveat-v9-latin_cyrillic-700.svg';
import CaveatBoldTtf from 'src/fonts/caveat/caveat-v9-latin_cyrillic-700.ttf';
import CaveatBoldWoff from 'src/fonts/caveat/caveat-v9-latin_cyrillic-700.woff';
import CaveatBoldWoff2 from 'src/fonts/caveat/caveat-v9-latin_cyrillic-700.woff2';
// Caveat Regular
import CaveatRegularEot from 'src/fonts/caveat/caveat-v9-latin_cyrillic-regular.eot';
import CaveatRegularSvg from 'src/fonts/caveat/caveat-v9-latin_cyrillic-regular.svg';
import CaveatRegularTtf from 'src/fonts/caveat/caveat-v9-latin_cyrillic-regular.ttf';
import CaveatRegularWoff from 'src/fonts/caveat/caveat-v9-latin_cyrillic-regular.woff';
import CaveatRegularWoff2 from 'src/fonts/caveat/caveat-v9-latin_cyrillic-regular.woff2';
// Lato Black
import LatoBlackEot from 'src/fonts/lato/lato-black.eot';
import LatoBlackSvg from 'src/fonts/lato/lato-black.svg';
import LatoBlackTtf from 'src/fonts/lato/lato-black.ttf';
import LatoBlackWoff from 'src/fonts/lato/lato-black.woff';
import LatoBlackWoff2 from 'src/fonts/lato/lato-black.woff2';
// Lato Black Italic
import LatoBlackItalicEot from 'src/fonts/lato/lato-blackitalic.eot';
import LatoBlackItalicSvg from 'src/fonts/lato/lato-blackitalic.svg';
import LatoBlackItalicTtf from 'src/fonts/lato/lato-blackitalic.ttf';
import LatoBlackItalicWoff from 'src/fonts/lato/lato-blackitalic.woff';
import LatoBlackItalicWoff2 from 'src/fonts/lato/lato-blackitalic.woff2';
// Lato Bold
import LatoBoldEot from 'src/fonts/lato/lato-bold.eot';
import LatoBoldSvg from 'src/fonts/lato/lato-bold.svg';
import LatoBoldTtf from 'src/fonts/lato/lato-bold.ttf';
import LatoBoldWoff from 'src/fonts/lato/lato-bold.woff';
import LatoBoldWoff2 from 'src/fonts/lato/lato-bold.woff2';
// Lato Bold Italic
import LatoBoldItalicEot from 'src/fonts/lato/lato-bolditalic.eot';
import LatoBoldItalicSvg from 'src/fonts/lato/lato-bolditalic.svg';
import LatoBoldItalicTtf from 'src/fonts/lato/lato-bolditalic.ttf';
import LatoBoldItalicWoff from 'src/fonts/lato/lato-bolditalic.woff';
import LatoBoldItalicWoff2 from 'src/fonts/lato/lato-bolditalic.woff2';
// Lato Regular Italic
import LatoRegularItalicEot from 'src/fonts/lato/lato-italic.eot';
import LatoRegularItalicSvg from 'src/fonts/lato/lato-italic.svg';
import LatoRegularItalicTtf from 'src/fonts/lato/lato-italic.ttf';
import LatoRegularItalicWoff from 'src/fonts/lato/lato-italic.woff';
import LatoRegularItalicWoff2 from 'src/fonts/lato/lato-italic.woff2';
// Lato Regular
import LatoRegularEot from 'src/fonts/lato/lato-regular.eot';
import LatoRegularSvg from 'src/fonts/lato/lato-regular.svg';
import LatoRegularTtf from 'src/fonts/lato/lato-regular.ttf';
import LatoRegularWoff from 'src/fonts/lato/lato-regular.woff';
import LatoRegularWoff2 from 'src/fonts/lato/lato-regular.woff2';

type FontSrcType = 'local' | 'eot' | 'eot#iefix' | 'woff2' | 'woff' | 'ttf' | 'svg';
type FontSrc = [FontSrcType, string];

function makeFontSrc(fontFamily: string, srcs: FontSrc[]): string {
    return srcs
        .map(src => {
            switch (src[0]) {
                case 'local':
                    return `local('${src[1]}')`;
                case 'eot':
                    return `url('${src[1]}')`;
                case 'eot#iefix':
                    return `url('${src[1]}?#iefix') format('embedded-opentype')`;
                case 'woff2':
                    return `url('${src[1]}') format('woff2')`;
                case 'woff':
                    return `url('${src[1]}') format('woff')`;
                case 'ttf':
                    return `url('${src[1]}') format('truetype')`;
                case 'svg':
                    return `url('${src[1]}#${fontFamily}') format('svg')`;
                default:
                    return undefined;
            }
        })
        .filter(src => src !== undefined)
        .join(', ');
}

type JSSFontface = CSS.AtRule.FontFace & { fallbacks?: CSS.AtRule.FontFace[] };

function makeFontFace(
    fontFamily: string,
    fontStyle: 'italic' | 'normal',
    fontWeight: number,
    srcs: FontSrc[]
): JSSFontface {
    return {
        fontFamily,
        fontStyle,
        fontWeight,
        fontDisplay: 'swap',
        src: makeFontSrc(fontFamily, srcs),
    };
}

// Lato

const LatoRegular = makeFontFace('Lato', 'normal', 400, [
    ['local', 'Lato Regular'],
    ['local', 'Lato-Regular'],
    ['eot#iefix', LatoRegularEot],
    ['woff2', LatoRegularWoff2],
    ['woff', LatoRegularWoff],
    ['ttf', LatoRegularTtf],
    ['svg', LatoRegularSvg],
]);

const LatoRegularItalic = makeFontFace('Lato', 'italic', 400, [
    ['local', 'Lato Italic'],
    ['local', 'Lato-Italic'],
    ['eot#iefix', LatoRegularItalicEot],
    ['woff2', LatoRegularItalicWoff2],
    ['woff', LatoRegularItalicWoff],
    ['ttf', LatoRegularItalicTtf],
    ['svg', LatoRegularItalicSvg],
]);

const LatoBold = makeFontFace('Lato', 'normal', 700, [
    ['local', 'Lato Bold'],
    ['local', 'Lato-Bold'],
    ['eot#iefix', LatoBoldEot],
    ['woff2', LatoBoldWoff2],
    ['woff', LatoBoldWoff],
    ['ttf', LatoBoldTtf],
    ['svg', LatoBoldSvg],
]);

const LatoBoldItalic = makeFontFace('Lato', 'italic', 700, [
    ['local', 'Lato Bold Italic'],
    ['local', 'Lato-BoldItalic'],
    ['eot#iefix', LatoBoldItalicEot],
    ['woff2', LatoBoldItalicWoff2],
    ['woff', LatoBoldItalicWoff],
    ['ttf', LatoBoldItalicTtf],
    ['svg', LatoBoldItalicSvg],
]);

const LatoBlack = makeFontFace('Lato', 'normal', 900, [
    ['local', 'Lato Black'],
    ['local', 'Lato-Black'],
    ['eot#iefix', LatoBlackEot],
    ['woff2', LatoBlackWoff2],
    ['woff', LatoBlackWoff],
    ['ttf', LatoBlackTtf],
    ['svg', LatoBlackSvg],
]);

const LatoBlackItalic = makeFontFace('Lato', 'italic', 900, [
    ['local', 'Lato Black Italic'],
    ['local', 'Lato-BlackItalic'],
    ['eot#iefix', LatoBlackItalicEot],
    ['woff2', LatoBlackItalicWoff2],
    ['woff', LatoBlackItalicWoff],
    ['ttf', LatoBlackItalicTtf],
    ['svg', LatoBlackItalicSvg],
]);

export const Lato = [LatoRegular, LatoRegularItalic, LatoBold, LatoBoldItalic, LatoBlack, LatoBlackItalic];

// Caveat

const CaveatRegular = makeFontFace('Caveat', 'normal', 400, [
    ['local', ''],
    ['eot#iefix', CaveatRegularEot],
    ['woff2', CaveatRegularWoff2],
    ['woff', CaveatRegularWoff],
    ['ttf', CaveatRegularTtf],
    ['svg', CaveatRegularSvg],
]);

const CaveatBold = makeFontFace('Caveat', 'normal', 700, [
    ['local', ''],
    ['eot#iefix', CaveatBoldEot],
    ['woff2', CaveatBoldWoff2],
    ['woff', CaveatBoldWoff],
    ['ttf', CaveatBoldTtf],
    ['svg', CaveatBoldSvg],
]);

export const Caveat = [CaveatRegular, CaveatBold];
